import Glide from '@glidejs/glide'

const swiperContainer = document.querySelector('.js-swiper')

if (swiperContainer) {
  window.addEventListener('load', () => {
    new Glide(swiperContainer, {
      type: 'carousel',
      keyboard: false,
      autoplay: 7000
    }).mount()
  })
}
